import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import ContactInfo from '../components/common/ContactInfo';
import { useTheme } from '../context/ThemeContext';

const ContactPage = () => {
  const { themeMode, jamaicanColors } = useTheme();

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 4, sm: 6, md: 8 } }}>
      <Box sx={{ textAlign: 'center', mb: { xs: 4, sm: 6 } }}>
        <Typography
          variant="h2"
          sx={{
            fontWeight: 800,
            fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
            color: themeMode === 'light' ? jamaicanColors.darkGreen : jamaicanColors.lightGreen,
            mb: 2
          }}
        >
          Get in Touch
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: '1rem', sm: '1.125rem' },
            color: 'text.secondary',
            maxWidth: '600px',
            margin: '0 auto',
            mb: 4
          }}
        >
          We're here to help you connect with opportunities across Jamaica. Whether you're a job seeker or an employer, our team is ready to assist you.
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: 4,
          mb: 6
        }}
      >
        {/* Contact Info Card */}
        <Box>
          <ContactInfo />
        </Box>

        {/* Additional Information */}
        <Paper
          sx={{
            p: { xs: 2, sm: 3 },
            borderRadius: 3,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
            About JamDung Jobs
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
            JamDung Jobs is building a comprehensive employment platform for Jamaica.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
            Our mission is to connect skilled Jamaicans with meaningful employment opportunities while supporting employers in finding the right talent.
          </Typography>
        </Paper>
      </Box>

      {/* Office Hours */}
      <Paper
        sx={{
          p: { xs: 2, sm: 3 },
          borderRadius: 3,
          textAlign: 'center',
          backgroundColor: themeMode === 'light' 
            ? 'rgba(255, 215, 0, 0.05)' 
            : 'rgba(255, 215, 0, 0.1)'
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
          Office Hours
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          Monday - Friday: 9:00 AM - 5:00 PM (EST)
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
          We typically respond within 24 business hours
        </Typography>
      </Paper>
    </Container>
  );
};

export default ContactPage;
